import React from "react";

import Button from "../../../Components/Button";
import CommonModal from "../../../Components/Modal";
import "./style.scss";

interface DeactivateVideoModalProps {
  isOpen: boolean;
  toggle: () => void;
  videoTitle: string;
  isActivating: boolean;
  onConfirm: () => void;
  loading?: boolean;
  /** Extra scope note, e.g. all account-team subroles. */
  scopeNote?: string;
}

const DeactivateVideoModal: React.FC<DeactivateVideoModalProps> = ({
  isOpen,
  toggle,
  videoTitle,
  isActivating,
  onConfirm,
  loading = false,
  scopeNote,
}) => {
  const title = isActivating ? "Activate Video" : "Deactivate Video";
  const action = isActivating ? "activate" : "deactivate";
  const message = isActivating
    ? "The video will be visible to users."
    : "The video will no longer be visible to users.";

  return (
    <CommonModal isOpen={isOpen} toggle={toggle} title={title} size="md">
      <div className="deactivate-video-modal">
        <p className="confirmation-text">
          Are you sure you want to {action}{" "}
          <strong>{videoTitle || "this video"}</strong>
          {scopeNote ? ` ${scopeNote}` : ""}? {message}
        </p>

        <div className="modal-actions">
          <Button variant="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            loading={loading}
            variant={isActivating ? "primary" : "danger"}
            onClick={onConfirm}
          >
            {isActivating ? "Activate" : "Deactivate"}
          </Button>
        </div>
      </div>
    </CommonModal>
  );
};

export default DeactivateVideoModal;
